import {useMemo} from "react";
import DashCard from "../../../../../components/dash-card/dash-card.jsx";
import SentryEchart from "../../../../../components/echarts/sentry-echart.jsx";
import MetricDashCard from "../../../../../components/dash-card/metric-dash-card.jsx";
import {
    DASHBOARD_LAST_POINT_SERIES_STYLE,
    DASHBOARD_LINE_CHART_GRID,
    DASHBOARD_LINE_CHART_TOOLTIP,
    DASHBOARD_LINE_CHART_X_AXIS,
    DASHBOARD_LINE_CHART_Y_AXIS,
    DASHBOARD_LINE_SERIES_STYLE,
} from "../../utils/line-chart-styles.js";

export default function TotalPassagesCard({ passages }) {
    const timeline = passages?.timeline;

    const areaChartOption = useMemo(() => {
        const areaChartData = Array.isArray(timeline)
            ? timeline.map(item => ({
                label: `${String(item.hour).padStart(2, "0")}h`,
                value: item.qty ?? 0,
            }))
            : [];

        const lastPoint = areaChartData.at(-1);

        return {
        grid: DASHBOARD_LINE_CHART_GRID,
        tooltip: {
            ...DASHBOARD_LINE_CHART_TOOLTIP,
            formatter: (params) => {
                const [point] = params;
                return `${point.axisValue}<br/>${point.marker} Passagens: <b>${point.value}</b>`;
            },
        },
        xAxis: {
            ...DASHBOARD_LINE_CHART_X_AXIS,
            data: areaChartData.map(item => item.label),
        },
        yAxis: DASHBOARD_LINE_CHART_Y_AXIS,
        series: [
            {
                ...DASHBOARD_LINE_SERIES_STYLE,
                name: "Passagens",
                data: areaChartData.map(item => item.value),
            },
            {
                ...DASHBOARD_LAST_POINT_SERIES_STYLE,
                name: "Último ponto",
                data: lastPoint ? [[lastPoint.label, lastPoint.value]] : [],
            },
        ],
        };
    }, [timeline]);

    return (
        <article className="box-border min-w-0 min-h-0 h-full w-full grid grid-rows-[minmax(80px,auto)_minmax(0,1fr)] gap-3">
            <div className="grid grid-cols-[minmax(0,113fr)_minmax(0,298fr)_minmax(0,107fr)] gap-[12px] min-h-0 w-full">
                <MetricDashCard
                    counterCard
                    title="Total"
                    value={passages?.total ?? 0}
                    width="100%"
                    height="auto"
                    dashClassName="min-h-[80px] min-w-0 px-3!"
                />

                <div className="grid grid-cols-3 gap-[8px] min-w-0 w-full min-h-[80px]">
                    <MetricDashCard
                        title="Entrada"
                        value={passages?.entrance ?? 0}
                        width="100%"
                        height="auto"
                        dashClassName="min-h-[80px] min-w-0 px-2!"
                    />

                    <MetricDashCard
                        title="Saída"
                        value={passages?.exit ?? 0}
                        width="100%"
                        height="auto"
                        dashClassName="min-h-[80px] min-w-0 px-2!"
                    />

                    <MetricDashCard
                        title="Internos"
                        value={passages?.internal ?? 0}
                        width="100%"
                        height="auto"
                        dashClassName="min-h-[80px] min-w-0 px-2!"
                    />
                </div>

                <MetricDashCard
                    counterCard
                    title="Por minuto"
                    value={passages?.perMinute ?? 0}
                    width="100%"
                    height="auto"
                    dashClassName="min-h-[80px] min-w-0 px-3!"
                />
            </div>

            <DashCard width="100%" height="100%" className="min-h-0 h-full p-4!">
                <SentryEchart
                    className="h-full min-h-0"
                    option={areaChartOption}
                />
            </DashCard>
        </article>
    );
}
